require('vendor/filterrific-jquery.js');

$(document).on('turbo:load', function() {
  Filterrific.init();
});
